<template>
  <Create :id="$route.params.id" />
</template>

<script>
import Create from './Create.vue'

export default {
  name: 'ExpenseEdit',
  components: {
    Create,
  },
}
</script>
